import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { useDispatch, useSelector } from 'react-redux';
import { getInvoiceMember, getNumberSet } from '../../features/lotteryInvoice';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from "@mui/icons-material/Cancel";
import { useNavigate } from 'react-router-dom';
import FormatListNumberedRoundedIcon from '@mui/icons-material/FormatListNumberedRounded';
import * as XLSX from 'xlsx';
import lotteryProcessor from '../../helper/lotteryProcess';
import { changeTypeToName } from '../../helper/changeBankIdtoName';

const ModalGetNumbebrSet = (props) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [open, setOpen] = useState(false);
    const [openTab, setOpenTab] = useState(0);
    const [Data, setData] = useState({ query: { member: null }, pagination: { pageNum: 1, pageSize: 12 } })
    const numset = useSelector(state => state.invoice.numset)
    const invoiceMember = useSelector(state => state.invoice.invoiceMember?.data)

    const [file, setFile] = useState();
    const [array, setArray] = useState([]);
    const [doc, setDoc] = useState(null);
    const [chooseInvoice, setChooseInvoice] = useState([]);
    const [nameChooseInvoice, setNameChooseInvoice] = useState([]);
    console.log(chooseInvoice)
    console.log(nameChooseInvoice)
    const fileReader = new FileReader();

    const handleOnChange = (e) => {
        setFile(e.target.files[0]);
    };

    const csvFileToArray = string => {
        const csvHeader = string.slice(0, string.indexOf("\n")).split(",");
        const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");

        const array = csvRows.map(i => {
            const values = i.split(",");
            const obj = csvHeader.reduce((object, header, index) => {
                object[header] = values[index];
                return object;
            }, {});
            return obj;
        });

        setArray(array);
    };

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        if (file) {
            fileReader.onload = function (event) {
                const text = event.target.result;
                const workbook = XLSX.read(event.target.result, { type: 'binary' });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const sheetData = XLSX.utils.sheet_to_json(sheet);

                const result = lotteryProcessor(sheetData)
                setDoc(result);
                // csvFileToArray(text);
            };
            fileReader.readAsBinaryString(file);
            // fileReader.readAsText(file);
        }
    };

    const handleChange = async () => {
        setOpen(!open);
        dispatch(getInvoiceMember(Data))
        dispatch(getNumberSet())
    };

    const setPage = (data) => {
        if (data == 'next') {
            setData({ ...Data, pagination: { ...Data.pagination, pageNum: Data.pagination.pageNum + 1 } })
        } else {
            setData({ ...Data, pagination: { ...Data.pagination, pageNum: Data.pagination.pageNum - 1 } })
        }
    }

    const mergeBets = (currentBets, incomingBets) => {
        const betMap = new Map();

        currentBets.forEach(bet => {
            const key = `${bet.betType}_${bet.betNumber}`;
            betMap.set(key, { ...bet, betAmount: parseInt(bet.betAmount) });
        });

        incomingBets.forEach(bet => {
            const key = `${bet.betType}_${bet.betNumber}`;
            if (betMap.has(key)) {
                betMap.get(key).betAmount += parseInt(bet.betAmount);
            } else {
                betMap.set(key, { ...bet, betAmount: parseInt(bet.betAmount) });
            }
        });

        return Array.from(betMap.values());
    };

    const addChooseInvoice = async (invoice) => {
        const updatedBets = mergeBets(chooseInvoice, invoice.ticketList);
        setChooseInvoice(updatedBets)
        setNameChooseInvoice(prev => [...prev, invoice.name])
    }

    useEffect(() => {
        dispatch(getInvoiceMember(Data))
        dispatch(getNumberSet())
    }, [Data])

    return (
        <React.Fragment>
            <button className="text-base h-full w-full text-defaultPlayHuayDeactive bg-gradient-to-t from-[#D1B000] to-[#FFD700] px-5 font-bold" onClick={handleChange}>
                <span className="mr-1">{<FormatListNumberedRoundedIcon />}</span>
                ดึงโพย
            </button>
            <Dialog
                // id={props.refCode}
                fullScreen={true}
                fullWidth={true}
                maxWidth="xl"
                open={open}
                onClose={handleChange}
                aria-labelledby="max-width-dialog-title"
            >
                <DialogTitle id="max-width-dialog-title" >
                    <div className="flex justify-between">
                        <p className="text-lg font-bold">เลขชุด</p>
                        <button onClick={handleChange}>
                            <CancelIcon />
                        </button>
                    </div>
                </DialogTitle>
                <ul className="w-auto grid gap-3 grid-cols-3 text-center mx-1">
                    <li
                        className={`${openTab === 0
                            ? `text-[#b3853e] border-[#b3853e] `
                            : `text-[#b3853e] `
                            }w-auto border-b-2 pb-2 `}
                    >
                        <button
                            onClick={() => {
                                setOpenTab(0);
                            }}
                            data-toggle="option"
                            href={`#option${0}`}
                            role="tablist"
                        >
                            เลขชุด
                        </button>
                    </li>
                    <li
                        className={`${openTab === 1
                            ? `text-[#b3853e] border-[#b3853e] `
                            : `text-[#b3853e] `
                            }w-auto border-b-2 pb-2 text-[#b3853e]`}
                    >
                        <button
                            onClick={() => {
                                setOpenTab(1);
                            }}
                            data-toggle="option"
                            href={`#option${1}`}
                            role="tablist"
                        >
                            ดึงโพย
                        </button>
                    </li>
                    <li
                        className={`${openTab === 2
                            ? `text-[#b3853e] border-[#b3853e] `
                            : `text-[#b3853e] `
                            }w-auto border-b-2 pb-2 text-[#b3853e]`}
                    >
                        <button
                            onClick={() => {
                                setOpenTab(2);
                            }}
                            data-toggle="option"
                            href={`#option${2}`}
                            role="tablist"
                        >
                            ดึงโพยจากEXCEL
                        </button>
                    </li>
                </ul>
                {openTab == 0 ?
                    <div>
                        <div className="grid grid-cols-2 gap-1 my-1 text-[#b3853e] px-1    text-sm">
                            <button onClick={() => navigate('/betnumset')} className="bg-blue-400 py-1">จัดการเลขชุด</button>
                            <button onClick={() => navigate('/setnumber')} className="bg-green-400 py-1">สร้างเลขชุด</button>
                        </div>
                        <div className="grid grid-cols-10 bg-defaultColor text-[#b3853e] text-center text-sm py-1">
                            <p className="col-span-2">ชื่อชุด</p>
                            <p className="col-span-3">วันที่สร้าง</p>
                            <p className="col-span-4">เลข</p>
                            <p className=""></p>
                        </div>
                        {numset ? numset.map((data, i) => (
                            <div key={i} className="grid grid-cols-10 text-center text-sm py-1">
                                <p className="col-span-2">{data.setName}</p>
                                <p className="col-span-3">{new Date(data.createDatetime).toLocaleDateString('th-TH')}</p>
                                <p className="col-span-4 text-start break-all">{data.ticketList.map(data => (`${data.betNumber},`))}</p>
                                <button onClick={() => { props.addTicketFromNumset(data.ticketList); setOpen(!open); }} className="h-7 w-7 focus:bg-[#b3853e] rounded border border-[#b3853e] hover:bg-defaultColor2"><CheckIcon color="secondary" /></button>
                            </div>
                        ))
                            :
                            <></>
                        }
                    </div> :
                    openTab == 1 ?
                        <>
                            <div className="grid grid-cols-10 bg-defaultColor text-[#b3853e] text-center text-sm py-1">
                                <p className="col-span-3">โพย</p>
                                <p className="col-span-3">วันที่สร้าง</p>
                                <p className="col-span-3">เลข</p>
                            </div>

                            {invoiceMember ? invoiceMember.map(data => (
                                <div className="grid grid-cols-10 text-center text-sm py-1">
                                    <p className="col-span-3">{data.lotteryRound.lottery.lotteryName}</p>
                                    <p className="col-span-3">{new Date(data.invoiceDatetime).toLocaleDateString('th-TH')}</p>
                                    <p className="col-span-3 text-start break-all">{data.ticketList.map(data => (`${data.lotteryNumber},`))}</p>
                                    <button onClick={() => { props.addTicketFromInvoice(data.ticketList); setOpen(!open); }} className="h-7 w-7 rounded border border-defaultBorder hover:bg-defaultColor2"><CheckIcon color="secondary" /></button>
                                </div>
                            )) :
                                <></>}

                            <div className="flex justify-around">
                                {Data.pagination.pageNum != '1' ? <button onClick={() => setPage('prev')} className="rounded border border-defaultBorder text-defaultText2 px-5 py-1">กลับ</button> : <></>}
                                {invoiceMember.length == '12' ? <button onClick={() => setPage('next')} className="rounded border border-defaultBorder text-defaultText2 px-5 py-1">ต่อไป</button> : <></>}
                            </div>
                        </> :
                        <>
                            <form className="text-center mt-5">
                                <input type={"file"} accept={".csv,.xlsx,.xls"} id={"csvFileInput"} onChange={handleOnChange} />

                                <button className="border rounded px-2 py-1 text-[#b3853e] border-[#b3853e]" onClick={(e) => {
                                    handleOnSubmit(e);
                                }}>IMPORT CSV</button>
                            </form>
                            <div className="grid grid-cols-10 bg-defaultColor text-[#b3853e] text-center text-sm py-1">
                                <p className="col-span-2">ชื่อโพย</p>
                                <p className="col-span-7">เลข</p>
                                <p className="col-span-1"></p>
                            </div>
                            {doc && doc.map((data, i) => (
                                <div key={i} className="grid grid-cols-10 text-center text-sm py-1 border-b">
                                    <p className="col-span-2">{data.name}</p>
                                    <p className={`col-span-7 text-start break-all `}>{data.ticketList.map(data => (<div>{changeTypeToName(data.betType)}: <span className="font-bold">{data.betNumber}</span> ราคา <span className="font-bold">{data.betAmount}</span></div>))}</p>
                                    <button onClick={() => { addChooseInvoice(data) }} className="h-7 w-7 rounded border border-[#b3853e] hover:bg-defaultColor2"><CheckIcon color="secondary" /></button>

                                </div>
                            ))
                            }
                            <div className="text-[#b3853e] text-center text-sm mt-5">โพยที่เลือก: {nameChooseInvoice && nameChooseInvoice.map(data => (`${data}, `))} </div>
                            <DialogActions>
                                <button onClick={() => { props.addTicketFromNumset(chooseInvoice); setOpen(!open); setChooseInvoice([]); setNameChooseInvoice([]); setDoc([]); }} className="px-3 py-0.5 rounded text-[#b3853e] border border-[#b3853e] hover:bg-defaultColor2">บันทึก</button>
                            </DialogActions>
                        </>}
            </Dialog>
        </React.Fragment >
    )
}

export default ModalGetNumbebrSet
